import React, { FC } from 'react';
import { Divider, Theme } from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/styles';

interface StyledDividerProps {
  isLargeMargin?: boolean;
}

const useStyles = makeStyles((theme: Theme) => {
  return createStyles({
    divider: {
      height: 1,
      maxWidth: '100%',
      backgroundColor: theme.palette.primary.contrastText,
      margin: ({ isLargeMargin }: Partial<StyledDividerProps>) => (isLargeMargin ? theme.spacing(5, 0) : theme.spacing(3, 0)),
    },
  });
});

const StyledDivider: FC<StyledDividerProps> = (props) => {
  const { isLargeMargin = false } = props;
  const classes = useStyles({ isLargeMargin });

  return <Divider className={classes.divider} />;
};

export default StyledDivider;
